import { subtitleLandingMedium } from "assets/jss/material-kit-pro-react";

const style = (theme) => ({
  mainBox: {
    width: "100%",
    backgroundColor: "#fff",
    paddingBottom: "200px",
    paddingTop: "50px",
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    boxShadow: theme.shadows[3],
    display: "flex",
    justifyContent: "center",
  },
  mainGridContainer: {
    maxWidth: "1200px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    spacing: 4
  },
  infoText: {
    ...subtitleLandingMedium
  }
});

export default style;